module.exports = __webpack_public_path__ + "img/2_53.f9e88d1a.png";